import { militaryTime } from "../../utils/time";
import first from "lodash/first";
import uniqueBy from "lodash/uniqBy";

export const mapRemoveHours = payload => ({ hours: oldHours, days, user_id: distinct_id}) => ({
  distinct_id,
  days,
  oldHours,
  hours: afterDelete(oldHours, payload),
  deletedHour: payload
})

export const mapCreateHours = payload => ({ hours: oldHours, days, user_id: distinct_id }) => ({
  distinct_id,
  days,
  oldHours,
  hours: payload,
  addedHour: getAddedHour(oldHours, payload)
})

export const mapEditHour = payload => ({ hours: oldHours, days, user_id: distinct_id }) => ({
  distinct_id,
  days,
  oldHours,
  hours: uniqueBy(payload, militaryTime),
})

export const mapDay = payload => ({ hours, days: oldDays, user_id: distinct_id }) => ({
  distinct_id,
  oldDays,
  days: oldDays.includes(payload) ?
    oldDays.filter(v => v !== payload) :
    oldDays.concat(payload),
  hours,
  modified: payload
})

function afterDelete(oldHours, deletedHour) {
  return [].concat(oldHours)
  .filter(v => militaryTime(v) !== militaryTime(deletedHour))
}

function getAddedHour(old, current) {
  return first([].concat(current).filter(hour => !old.map(militaryTime).includes(militaryTime(hour))))
}



// WEBPACK FOOTER //
// ./src/store/mixpanel/mappers.js